import "./inventarioCard.css";
import { capitalizar } from "../../../../utils/capitalizar.js";

export default function InventarioCard({ inventario, abierta, onToggle }) {
  
  const { nombre, cantidad, bloqueado } = inventario;

  const estado = bloqueado ? "disponible" : "bloqueado";

  return (
    <div
      className={`inventario-card ${abierta ? "abierta" : ""}`}
      onClick={onToggle}
    >
      <div className="card-row">
        <span className="campo-1">
          <strong>{nombre}</strong>
        </span>

        <span className="campo-2">
          <small>stock {cantidad} </small>
        </span>

        <span className={`campo-3 estado-${estado}`}> { capitalizar (estado) }</span>
      </div>
    </div>
  );
}
